import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import { Badge, BadgeColors, BadgeShapes } from '../../../generic/Badge';
import PaginationRangeWithControl from '../../../generic/Pagination/PaginationRangeWithControl';
import PartialResultRefreshButton from '../../generic/PartialResult/PartialResultRefreshButton';
import useFetchDependencyAction from '../hooks/useFetchDependencyAction';

import styles from './VendoredDependenciesLayout.module.less';

/**
 * Header component for the vendored dependencies table within TreeViewLayout.
 * Displays title, count badge, refresh button, and pagination controls.
 */
const VendoredTableHeader: VoidFunctionComponent = () => {
  const isLoading = useSelector(DependenciesV2Store.selectors.getAreDependenciesLoading);
  const totalCount = useSelector(DependenciesV2Store.selectors.getTotalDependencies);
  const page = useSelector(DependenciesV2Store.selectors.getPage);
  const count = useSelector(DependenciesV2Store.selectors.getCount);

  const setPage = useFetchDependencyAction(DependenciesV2Store.actions.setPage);

  return (
    <div className={styles.tableHeader}>
      <div className={styles.tableHeaderTitle}>
        <span>Vendored Dependencies</span>
        <Badge shape={BadgeShapes.Circle} color={BadgeColors.LightGray}>
          {!isLoading ? totalCount : '...'}
        </Badge>
        {!isLoading && <PartialResultRefreshButton />}
      </div>
      <PaginationRangeWithControl
        page={page}
        count={count}
        totalItems={totalCount}
        setPage={setPage}
      />
    </div>
  );
};

export default VendoredTableHeader;
